import { AvatarSize, AvatarType, ExAvatar } from '@boomi/exosphere';
import type { Connector } from './connectors';
import styles from './ConnectorRow.module.css';

interface ConnectorRowProps {
    connector: Connector;
    onViewConnections?: (id: string) => void;
}

const ConnectorRow = ({ connector, onViewConnections }: ConnectorRowProps) => {
    const { id, name, icon } = connector;

    return (
        <button className={styles.row} onClick={() => onViewConnections?.(id)} aria-label={name}>
            <div className={styles.iconWrap}>
                {icon ? (
                    <img src={icon} alt={name} width={24} height={24} />
                ) : (
                    <ExAvatar
                        size={AvatarSize.SMALL}
                        avatarType={AvatarType.USER}
                        firstName={name.split(' ')[0]}
                        lastName={name.split(' ')[1]}
                    />
                )}
            </div>
            <span className={styles.name}>{name}</span>
        </button>
    );
};

export default ConnectorRow;
